export const getRamadanDay = (demoDay = null) => {
  if (demoDay !== null) {
    return demoDay;
  }
  
  const ramadanStart = new Date('2026-02-18T23:59:59'); 
  const today = new Date();
  const diffTime = today.getTime() - ramadanStart.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
  
  if (diffDays < 1) return 0;
  if (diffDays > 30) return 31;
  return diffDays;
};
